import React, { Suspense, lazy, useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import "../../assets/vendors/stylesLandingPage.css";

const MyCarousel = lazy(() => import("../../components/Content/MyCarousel"));
const Cards = lazy(() => import("../../components/Content/Cards"));
const Banner = lazy(() => import("../../components/Content/Banner"));

const MainPage = () => {
  useEffect(() => {
    localStorage.removeItem("justFound");
  }, []);

  return (
    <div className="main-page-root" style={{ overflow: "auto", scrollBehavior: "smooth" }}>
      <Header faq={false} />
      <div className="my-width m-t-40">
        <Suspense fallback={null}>
          <MyCarousel />
          <Cards />
          <Banner />
        </Suspense>
      </div>
      <Footer />
    </div>
  );
};

export default MainPage;
